export default __webpack_public_path__ + "static/media/2_logo.f1e84664.png";